import { render, staticRenderFns } from "./TecInfoDatabank.vue?vue&type=template&id=7f997ae6"
import script from "./TecInfoDatabank.vue?vue&type=script&lang=js"
export * from "./TecInfoDatabank.vue?vue&type=script&lang=js"
import style0 from "./TecInfoDatabank.vue?vue&type=style&index=0&id=7f997ae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports